// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.updatedialog_featuredUpdateDialogItem__kuPl- {
    flex:1 1;
    margin: 0px 20px;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);
  }

  .updatedialog_featured__wRzrM {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .updatedialog_featuredItem__oBDa- {
    flex: 1 1;
    margin: 0px 20px;
    padding: 30px;
    border-radius: 10px;
    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);
  }

  .updatedialog_updateDialogInputs__HfWgl {
      width: 100%;
  }

  .updatedialog_currentAnswerOverlay__QjPtJ {
    z-index: 10000; 
    pointer-events: none;
    opacity: 0.5;
  }
  
  .updatedialog_currentAnswerOverlay__QjPtJ:hover {
    pointer-events: none;
    cursor: pointer;
  }`, "",{"version":3,"sources":["webpack://./src/components/UpdateDialog/updatedialog.module.css"],"names":[],"mappings":"AAAA;IACI,QAAM;IACN,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IAEnB,kDAAkD;EACpD;;EAEA;IACE,WAAW;IACX,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IAEnB,kDAAkD;EACpD;;EAEA;MACI,WAAW;EACf;;EAEA;IACE,cAAc;IACd,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,oBAAoB;IACpB,eAAe;EACjB","sourcesContent":[".featuredUpdateDialogItem {\r\n    flex:1;\r\n    margin: 0px 20px;\r\n    padding: 20px;\r\n    border-radius: 10px;\r\n    -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n  }\r\n\r\n  .featured {\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: space-between;\r\n  }\r\n\r\n  .featuredItem {\r\n    flex: 1;\r\n    margin: 0px 20px;\r\n    padding: 30px;\r\n    border-radius: 10px;\r\n    -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n  }\r\n\r\n  .updateDialogInputs {\r\n      width: 100%;\r\n  }\r\n\r\n  .currentAnswerOverlay {\r\n    z-index: 10000; \r\n    pointer-events: none;\r\n    opacity: 0.5;\r\n  }\r\n  \r\n  .currentAnswerOverlay:hover {\r\n    pointer-events: none;\r\n    cursor: pointer;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"featuredUpdateDialogItem": `updatedialog_featuredUpdateDialogItem__kuPl-`,
	"featured": `updatedialog_featured__wRzrM`,
	"featuredItem": `updatedialog_featuredItem__oBDa-`,
	"updateDialogInputs": `updatedialog_updateDialogInputs__HfWgl`,
	"currentAnswerOverlay": `updatedialog_currentAnswerOverlay__QjPtJ`
};
export default ___CSS_LOADER_EXPORT___;
